import { Button } from "@/components/Button/Button";
import * as gtag from "@/lib/gtag";
import { isMobileOrTablet } from "@/lib/isMobileOrTablet";
import { Icon } from "@/components/Icon";
import { FC, useState } from "react";
import { useIsomorphicLayoutEffect } from "hooks/useIsomorphicLayoutEffect";

interface ButtonPhoneProps {
  className: string;
  size: "fullwidth" | "medium";
  config: Config;
  itemPosition: string;
}

type Config = { [key: string]: any };
const ButtonPhone: FC<ButtonPhoneProps> = ({
  className,
  size,
  config,
  itemPosition,
}) => {
  const [phoneNumber, setPhoneNumber] = useState(
    config.contact.telephone.service
  );

  useIsomorphicLayoutEffect(() => {
    if (!config) return;

    if (isMobileOrTablet()) {
      setPhoneNumber(config.contact.telephone.serviceMobile);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Button
      className={className}
      as="a"
      size={size}
      href={`tel:${phoneNumber}`}
      variant="hollow"
      onClick={() => {
        gtag.event({
          event: "itemClick",
          itemClick: "Call",
          itemPosition: itemPosition,
          phoneNumber: phoneNumber,
        });
      }}
    >
      <Icon type="phone" className="w-6 h-6 mr-4" />
      {phoneNumber}
    </Button>
  );
};

export default ButtonPhone;
